import { createSelector } from 'reselect';

const getTopShopper = (
  state: import('../../../../../types/rootState').RootState
): import('../../../types/topshopper-api-type').TopShopperApiData => state.topShoppers;

const getEvent = createSelector(getTopShopper, ({ event }) => event);
export const getSaleType = createSelector(getEvent, ({ saleType }) => saleType);
const getGrandEvent = createSelector(getTopShopper, ({ grandEvent }) => grandEvent);
export const getImage = createSelector(getGrandEvent, ({ bannerImageURL }) => bannerImageURL);

export const getPageHeader = createSelector(getGrandEvent, ({ description }) => {
  const splitText = description?.split('|') || [];
  return {
    header: splitText[0],
    description: splitText[1]
  };
});

export const getLeaderBoardUser = createSelector(getGrandEvent, ({ userList = [] }) => userList);
export const getModalGoldData = createSelector(getGrandEvent, ({ offers = [] }) => {
  return offers.map(item => {
    return {
      label: item.label,
      desc: item.description
    };
  });
});
